import { ApiError } from './api-error';

export class InternalServerError extends ApiError {}
